import config from '@/config'
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import premiums from './data/premiums.js'
import presets from './data/presets.js'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    socialChannelOptions: [
      {
        value: 'fb',
        text: 'Facebook',
        icon: 'fab fa-facebook'
      },
      { value: 'line', text: 'Line', icon: 'fab fa-line' },
      {
        value: 'ig',
        text: 'Instagram',
        icon: 'fab fa-instagram'
      }
    ],
    edittingIntent: [],
    botStatus: false,
    loading: false,
    newcomer: Vue.localStorage.get('newcomer') === 'true',
    facebook_name: Vue.localStorage.get('facebook_name')
      ? Vue.localStorage.get('facebook_name')
      : Vue.localStorage.get('userid'),
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') === 'true',
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot:
      Vue.localStorage.get('selectedBot') && Vue.localStorage.get('selectedBot') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('selectedBot'))
        : [],
    userid: Vue.localStorage.get('userid'),
    botlist:
      Vue.localStorage.get('botlist') && Vue.localStorage.get('botlist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('botlist'))
        : [],
    pagelist:
      Vue.localStorage.get('pagelist') && Vue.localStorage.get('pagelist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('pagelist'))
        : [],
    accessToken: Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    setting: undefined,
    welcomeMessage: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    },
    loginChannel: ['facebook', 'account', 'chat2pay'].includes(Vue.localStorage.get('loginChannel'))
      ? Vue.localStorage.get('loginChannel')
      : 'facebook',
    fbScope: Vue.localStorage.get('fbScope'),
    tutoriallist: [],
    alert:
      Vue.localStorage.get('alerts') && Vue.localStorage.get('alerts') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('alerts'))
        : [],
    partner_code: Vue.localStorage.get('partner_code')
      ? Vue.localStorage.get('partner_code')
      : undefined,
    pageBU: ['114743896611281', '132880665271'],
    specialpage: [
      '274108073649',
      '619202881423565',
      '2261615673888062',
      '1231805606976542',
      '1493632560856869',
      '2105726733070683',
      '391365474996527',
      '282419538600861',
      '229446640739626',
      '229777340553912',
      '1422119811377985',
      '1441887002726565',
      '367229174088451',
      '2244102365841101'
    ],
    pageRussianRoulette: ['101900391252252', '582769212229333'],
    lineimagemapbypageid: [
      '102074341651763',
      '109547317606650',
      '394274810994296',
      '355634702145095',
      '105479814959388',
      '105077088474056', //Foodguru test
      '1192315994209757', //Foodguru
      '100339565610749',
      '102370245472711', // Test Lamy
      '2037301563028410', //Lamy
      '106858277640083',
      '102126962268028', //Test Prudential
      '110807598418528'
    ],
    livepage: [
      '361231620965547',
      '394274810994296',
      '582769212229333',
      '998122266996445',
      '367229174088451',
      '746554075685318',
      '104798401281089',
      '1396503507148739',
      '1589840171084621',
      '100590148401358',
      '102564098201451',
      '105286034592205',
      '106043044515474',
      '106368351149754',
      '107704437498029',
      '101697018243932',
      '103787708076884',
      '100652118659247'
    ],
    linenotifylist: [],
    ecommerce: {
      products: [],
      loadingProduct: true,
      categories: [],
      loadingCategory: true,
      charges: {},
      loadingCharges: true
    },
    loadingUserStatus: true,
    userStatus: [],
    loadingSetting: true,
    groupConversation: [],
    loadingGroupConversation: true,
    linePushMessageCount: null,
    loadingLinePushMessageCount: true,
    uuAreaName: [
      'ประปาบางปะกง',
      'ประปาฉะเชิงเทรา',
      'ประปาบ่อวิน',
      'ประปาหนองขาม',
      'ประปาสัตหีบ',
      'ประปาระยอง',
      'ประปานครสวรรค์',
      'ประปาหัวรอ',
      'นอกพื้นที่บริการ'
    ],
    livechatPageList: [
      'universalutilities',
      'qualityexpress',
      'scgworkplace',
      'hafele',
      'scgallrent',
      'erawon',
      'nvbb',
      'ticket',
      'toa',
      'tero',
      'ceemeagain',
      'runkan',
      'ticket2',
      'studio7',
      'mjd',
      'tdtawandang',
      'ustore',
      'toaecoupon',
      'kingkitchen',
      'oab',
      'foodguru',
      'webchat',
      'secap',
      'cityfresh',
      'summitcapital'
    ],
    showSession: ['111895158162143'],
    pageListSingGaling: ['100856422547014', '352145869189954'],
    pageListCityfresh: ['105432182130709', '462339517184685'],
    livechatPageIdList: [
      '116519703597611',
      '103176014844712',
      '416676055049196',
      '361231620965547',
      '105845930769096',
      '109852714203364',
      '740558886346101',
      '2174852312837297',
      '112221640469726',
      '101697018243932',
      '394274810994296',
      '164163116964925',
      '582769212229333',
      '1231805606976542',
      '391365474996527',
      '137411776275948',
      '109968900678170',
      '1597136823912874',
      '897720647226000',
      '155062857877705',
      '872957802874373',
      '493853667614460',
      '100697638247144',
      '111397590508659',
      '105991451230578',
      '417399991785158',
      '479935035361377',
      '1491549921105907',
      '329688424161461',
      '104944601303072',
      '110710877332627', //central test
      '1227337900627015',
      '101360894725464',
      '100709785233611',
      '103306351415631',
      '110332890598171',
      '104665701343082',
      '154660564561038',
      '106869188045204',
      '134709089901776',
      '367229174088451',
      '746554075685318',
      '102219411814724',
      '391365474996527',
      '1493632560856869',
      '110883070374655',
      '106184007583774', // limited time use
      // '105077088474056', //foodguru test
      '396306053873110',
      '208321456497173',
      '105479814959388',
      '106608108347089',
      '101774885453755', //lookchingiant
      '335283187311293',
      '106898821720798',
      '501378479972109',
      '1772973606299543',
      '100701258941039', // ya sale
      '102126962268028', //Test Prudential
      '105387828535129', // Test Nextcapital
      '105911105134578', // the next face demo
      '101931352240400', // the next prd
      '100856422547014', //  sing galing test
      '352145869189954', //  sing galing
      '102052945584054', // kfc test
      '440544769371763', //Nanake555
      '104767375443976', //LINE BBQ Ticket
      // '101760532365601' //rabbit test
      // '101067815596282', //O&B
      // '101775492156959'
      // '104680311985265', //TD
      // '101836095321926',
      // '367570166993820',
      '112189117778521',
      '103181935455903',
      '115291591158286', //Thailand Elite TEST
      '105043275527849', //Test ITTS
      '107999415145694',
      '148559413337',
      '107402718638464', //Microplus Test
      '110116548371767', //Test Chulabhorn
      '101744349120148', // NT yellow
      '105076662234295', //Test NNN
      '110880794986721', // yasale ac test
      '104039299068829', // yasale ac
      '117042270152518', //อาคเนย์
      '104844382275583', //Test LH Fund
      '103193115692494', //Test Unicef_DEP
      '100305558382056', //TEST Live
      '108586555240680', //Nong Tung Jai
      '108537541446937'
    ],
    exportProduct: ['998122266996445', '104750531515506'],
    livechat: {
      pageid: null,
      app: 'facebook',
      type: 'bot',
      userlist: {
        admin: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        },
        bot: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        }
      },
      monobopages: [
        '148831989096546',
        '1229692217050821',
        '135565533158593',
        '488563718210335',
        '799590883441878'
      ],
      currentUser: null,
      currentUserTicket: [],
      currentUserTicketLoading: false,
      chatlog: [],
      loadingChatlog: true,
      limitFatchChatlog: 20,
      maxFatchChatlogTime: 120000, // 2 min
      limitFatchUser: 20,
      maxFetchUserTime: 120000, // 2 min,
      maxFatchReadTime: 120000, // 2 min,
      filter: {
        search: '',
        status: null,
        tags: [],
        app: '',
        adminread: null
      },
      tags: []
    },
    modal: {
      input: {},
      component: null,
      open: false,
      width: '600px'
    },
    allSchools: [],
    filter: {
      search: '',
      uuAreaName: '',
      uu_register_status: '',
      lineid: '',
      uu_name: '',
      phoneno: '',
      keyword: ''
    },
    presets: presets.data,
    premiums: premiums.data,
    progress: 0,
    UnlimitedConversation: [
      '100436434784238',
      '103530654454270',
      '1469559653364545',
      '105696154492400',
      '103955724454263', //TestMootest
      '177735408970104'
    ],
    pageProfile: null,
    loadingPageProfile: true,
    shippinglist: [],
    partnerProfile: null,
    loadingPartnerProfile: true,
    ntnPage: [
      '109118231726792',
      '125865357450484', //NIVEA MEN
      '133498913379485', //NIVEA
      '111901618984646', //PRUDENTIAL
      '501378479972109', //HOP INN
      '10150142683120473', //	Veranda Resort
      '501378479972109', //HOP INN Hotel Thailand
      '107225204433671', //เพลิน
      '445913858762180', //O&B
      '157302513089660', //Never Been Better ผักปั่นบำเรอเซลส์ ไฟเบอร์สูง
      '148559413337', //TOA Paint
      '274108073649', //Ananda Development
      '134780360043928', //Bangkok Bank Careers
      '114683640172785', //FINNIX - ฟินนิกซ์
      '177518292310976', //Generali Thailand
      '184743472197249', //KASIKORN Career
      '1532996797026674', //Skoop Beach Café
      '200701213291845', //Bar B Q Plaza
      '1858940081055826', //TrueID
      '326180737483767', //Rabbit Finance
      '110218459027409', //wacoal thailand
      '330339053719456', //TERO Digital
      '347753078624', //ICC International PLC
      '126654220708334', //Banana
      '124043006254', //Rocky Resort - a Veranda Collection
      '111901618984646', //Prudential Thailand
      '829945033793366', //Loligo Resort Hua Hin
      '284395865686', //Let's Sea Hua Hin's Beach Restaurant
      '284823381567', //Let's Sea Hua Hin Al Fresco Resort
      '103235014977289', //UFUND
      '2037301563028410', //LAMY Thailand
      '102549712095297', //Next Capital - เน็คซ์ แคปปิตอล
      '168284766605902', //ทวียนต์ รถตรงจากโรงงาน
      '192311387589573', //Aurora Gold and Jewelry
      '396306053873110', //Thailandpostmart
      '165304889696', //Power Buy
      '495271297476302', //Summit Capital ซัมมิท แคปปิตอล
      '536678779695541', //Yamaha Society Thailand
      '440544769371763', //Nanake555
      '162369877131894', //เอราวอน (era-won)
      '208321456497173', //โปรเน็ตบ้านถูกใจ
      '103267601317473', //ล้างแอร์บ้าน กับ ฮิปโปแอร์ บริการล้างแอร์ที่คนบอกต่อมากที่สุด
      '367570166993820', //MJD.TH
      '141495096441743', //RunKan
      '204722943535880', //ICON CINECONIC
      '205538499712', //Samed Resorts
      '627661304102768', //Isuzu Trucks Thailand
      '272899549394796', //All-New Isuzu D-Max
      '194390934103303', //All-New Isuzu MU-X
      '125865357450484', //NIVEA MEN (TH)
      '133498913379485', //NIVEA (TH)
      '104104271480491', //VERSO hua hin - a Veranda Collection
      '346030320266', // Studio7
      '105400738920268', //Test Gaming Nation
      '108234815144840', //Nestle
      '110981841237323', //Nestle
      '1037700739663223', //Nestle
      '101542172593323', //Nestle
      '100305558382056' //TEST Live
    ],
    centralPage: [
      '110710877332627',
      '160733491520',
      '107235216024674',
      '394274810994296', //จี้เส้น
      '392612533487',
      '103551424764072',
      '392612533487',
      '11462159325207',
      '114621593252079',
      '134297248716',
      '408054729252920',
      '122424499005',
      '122424499005',
      '408054729252920',
      '122424499005',
      '102421048239798',
      '105928254552462'
    ],
    loadingAgentGroups: false,
    agentGroups: [],
    loadingAgentSubgroups: false,
    agentSubgroups: [],
    loadingAgents: false,
    agents: [],
    admingroupid: Vue.localStorage.get('admingroupid'),
    adminsubgroupid: Vue.localStorage.get('adminsubgroupid'),
    privilege:
      Vue.localStorage.get('privilege') && Vue.localStorage.get('privilege') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('privilege'))
        : [],
    toapainterpage: ['102915644812388'],
    toacustomerpage: ['102968804806798', '148559413337'],
    toadealerpage: ['102028964902390'],
    toaNewDealerPage: ['109436881553235'],
    toaPaintPage: ['107999415145694', '148559413337'],
    niveapage: [],
    menubypageid: {
      104907684692250: ['comment', 'dashboard']
    },
    supertenpage: ['104665701343082', '154660564561038'],
    kfcpage: ['106855151601601', '102052945584054'],
    facebook_users_name: [],
    subcategory: ['116989963422911', '1775425925847885'],
    livechatadminreadpage: ['394274810994296', '208321456497173', '103267601317473'],
    shoptheme: [
      'ecommercebasic',
      'adminperform',
      'sahapan',
      'nvbb',
      'ticket',
      'bec',
      'runkan',
      'lookchingiant',
      'chatty',
      'erawon',
      'scgdistribution',
      'tero',
      'foodguru',
      'oab',
      'cityfresh',
      'warroom',
      'powerbuy',
      'powerby',
      'nestle'
    ],
    // filter: {
    //   search: ''
    // },
    beavermanpage: ['103003014894231'],
    niveapage: ['133498913379485', '125865357450484'],
    thailandPostmartPage: ['115414076948160', '396306053873110'],
    astonAdmins: [],
    loadingAstonAdmins: false,
    astonCustomerGroup: [
      'อื่นๆ',
      'รอสรุปยอด',
      'ร้องเรียน',
      'เปลี่ยนเบอร์-ที่อยู่',
      'โอนเงิน',
      'สั่งซื้อ',
      'ยกเลิก',
      'สั่งซื้อlive',
      'สนใจ',
      'หลังการขาย',
      'ปัญหา'
    ],
    selectedCom7page: {
      name: 'All',
      pageid: null
    },
    gbprimetheme: ['ecommercebasic'],
    com7pages: [
      {
        name: 'Banana',
        pageid: '126654220708334'
      },
      // {
      //   name: 'Banana test',
      //   pageid: '102954402002193'
      // },
      // {
      //   name: 'Studio7 ', // studio 7 test
      //   pageid: '108971401389284'
      // },
      {
        name: 'Studio7',
        pageid: '346030320266'
      }
      // {
      //   name: 'ustore ',
      //   pageid: '719003198911316'
      // }
    ],
    nestlePages: [
      {
        name: 'Nestle Health Science Thailand',
        pageid: '1037700739663223'
      },
      {
        name: 'Test Nestle',
        pageid: '108234815144840'
      },

      {
        name: 'Test Nestle 2',
        pageid: '101542172593323'
      },
      {
        name: 'Nestle Health Science: Boost TH',
        pageid: '110981841237323'
      }
    ],
    bbqPage: ['200701213291845', '106240318558522', '104767375443976'],
    bbqTestPage: ['106240318558522', '104767375443976'],
    newDeshboard: ['361231620965547'],
    rabbitPage: ['108973710878860', '326180737483767', '101760532365601'],
    rabbitReplyFBPostPage: ['101760532365601', '326180737483767'],
    lamyPage: ['102370245472711', '2037301563028410'],
    oceanlifePage: ['110549014810557', '1541081009538378'],
    toacrmrewardcategories: [],
    toacrmbranch: [],
    toacrmpointdata: {},
    toaEcouponStore: [],
    toaEcouponProducts: [],
    toaEcouponRewardCategories: [],
    toaEcouponCampaigns: [],
    toaEnableCampaignList: [],
    newchatnotify: {},
    iccpage: [
      '103669308635970',
      '101294872210698',
      '102944058709341',
      '102054622133230',
      '107898204895323',
      '182366355126026',
      '135625339853652',
      '103669308635970',
      '236020493215058',
      '347753078624',
      '104845608724391',
      '110218459027409'
    ],
    prudentialPage: ['102126962268028'],
    prudentialRealPage: ['111901618984646'],
    powerbuyTest: ['105344925152387'],
    gpfPage: ['106004118709627'],
    ticketPageid: [
      '106004118709627',
      '104337274602594',
      '100260714951032',
      '495271297476302',
      '105017609020919',
      '1637674519806774'
    ],
    toacrmproducts: [],
    delayImportUserTime:
      Vue.localStorage.get('delayImportUserTime') &&
      Vue.localStorage.get('delayImportUserTime') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('delayImportUserTime'))
        : [],

    intents: undefined,
    loadingIntents: true,
    selectToaCampaign: null,
    rabbitSelectedPostId: null,
    status: undefined,
    tags: undefined,
    hopinnMasterData: {
      position: [],
      affiliation: []
    },
    gpfBuddyMasterData: {
      company: [],
      workGroup: [],
      department: [],
      position: []
    },
    bbqStatusColor: null,
    powerbuyBranchList: [],
    powerbuyMainBranch: null,
    defaultBubbleList: [
      'text',
      'button',
      'image',
      'generic',
      'video',
      'welcome_message',
      'line_flex',
      'line_imagemap',
      'line_sticker',
      'payment_form',
      'add_cart',
      'ntn_template'
    ],
    ticketTags: null,
    ticketTagsFull: null,
    ticketTagsPageId: null
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js